export const STATUS_ERROR_PROJECT_ACTIVE_EVENTS = 'project_has_active_events';

export const STATUS_COMPLETED = 'completed';
